import React, { useState } from 'react';
import axios from 'axios';
import HumanCheck from '../components/HumanCheck';
import { createApiUrl } from '../utils/apiConfig';
import styles from './Contact.module.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    description: ''
  });
  const [humanCheckValid, setHumanCheckValid] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Block URLs/hyperlinks in the description and name
    const urlRegex = /(https?:\/\/|www\.|<a\s+href=|\[url=|\.(com|net|org|io|gov|edu|uk|us|ca|au|de|fr|jp|cn|ru|br|it|es|nl|se|no|dk|fi|pl|in|co|za|info|biz|me|tv|xyz|site|online|top|club|shop|store|blog|app|dev|ai|io)\b)/i;
    if (urlRegex.test(formData.description) || urlRegex.test(formData.name)) {
      setError('Please do not include links or URLs in your name or message.');
      return;
    }

    if (!humanCheckValid) {
      setError('Please answer the question correctly to proceed.');
      return;
    }

    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const sanitizedDescription = formData.description.replace(/<\/?[^>]+(>|$)/g, "");
      const response = await axios.post(createApiUrl('/api/submit-contact'), {
        ...formData,
        description: sanitizedDescription
      });

      if (response.data.success) {
        setSuccess(response.data.message);
        setFormData({
          name: '',
          email: '',
          reason: '',
          description: ''
        });
        setHumanCheckValid(false);
      }
    } catch (err) {
      if (err.response?.data?.errors) {
        setError(err.response.data.errors.map(error => error.msg).join('\n'));
      } else {
        setError('An error occurred while submitting the form.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.contactPage}>
      <div className={styles.contactContainer}>
        <div className={styles.contactCard}>
          <div className={styles.contactCardBody}>
            <h1 className={styles.contactTitle}>Contact Us</h1>
                {success && (
              <div className={styles.alertSuccess}>
                    {success}
                  </div>
                )}
                {error && (
              <div className={styles.alertDanger}>
                    {error}
                  </div>
                )}
            <form onSubmit={handleSubmit} className={styles.contactForm}>
              <div className={styles.contactFormGroup}>
                <label htmlFor="name" className={styles.formLabel}>Name</label>
                    <input 
                      type="text" 
                  className={styles.formControl} 
                      id="name" 
                      name="name" 
                      value={formData.name}
                      onChange={handleChange}
                      required 
                    />
                  </div>
              <div className={styles.contactFormGroup}>
                <label htmlFor="email" className={styles.formLabel}>Email</label>
                    <input 
                      type="email" 
                  className={styles.formControl} 
                      id="email" 
                      name="email" 
                      value={formData.email}
                      onChange={handleChange}
                      required 
                    />
                  </div>
              <div className={styles.contactFormGroup}>
                <label htmlFor="reason" className={styles.formLabel}>Reason</label>
                    <select 
                  className={styles.formControl} 
                      id="reason" 
                      name="reason" 
                      value={formData.reason}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a reason</option>
                      <option value="inquiry">Inquiry</option>
                      <option value="support">Support</option>
                      <option value="feedback">Feedback</option>
                    </select>
                  </div>
              <div className={styles.contactFormGroup}>
                <label htmlFor="description" className={styles.formLabel}>Comment</label>
                    <textarea 
                  className={styles.formControl} 
                      id="description" 
                      name="description" 
                      rows="6" 
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </div>
              <div className={styles.contactFormGroup}>
                    <HumanCheck 
                      onValidationChange={setHumanCheckValid}
                      error={error && !humanCheckValid ? 'Please answer the question correctly to proceed.' : ''}
                      formType="contact"
                    />
                  </div>
                  <button 
                    type="submit" 
                className={styles.submitButton}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </button>
                </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 